import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns'
import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form';
import React, { FunctionComponent, useState } from 'react'
import {
    Label,
    Error,
    Hint,
} from "@progress/kendo-react-labels";
import { toDigital } from '../../../utils/utils';
import { ProjectApi } from '../../../redux/api/ProjectApi';
import { IProjectType } from '../../../types/Project/IProjectType';

export const ProjectTypeList = (props) => {
    const {
        validationMessage,
        label,
        id,
        disabled,
        optional,
        onChange,
        multiSelect,
        placeholder,
        projectTypeIds,
    } = props;
    const isValid = !validationMessage;
    const showValidationMessage = validationMessage;
    const errorId = showValidationMessage ? `${id}_error` : "";
    const defaultValue = { ID: 0, Cost_Center: "Select" } as IProjectType
    const { data: projectTypes, isLoading: projectLoading } = ProjectApi.useGetProjectTypeListQuery()
    const selectProjectTypes = projectTypes?.filter(ct => projectTypeIds?.indexOf(ct.ID) > -1);
    const selectProjectType = projectTypes?.find(ct => projectTypeIds?.indexOf(ct.ID) > -1);
    const [opened, setOpened] = useState(false);
    return (
        <FieldWrapper>
            <Label
                editorId={id}
                editorValid={isValid}
                editorDisabled={disabled}
                optional={optional}
            >
                {label} {showValidationMessage && (<Error id={errorId}>{validationMessage}</Error>)}
            </Label>
            <div className={"k-form-field-wrap"} >
                {multiSelect ?
                    <MultiSelect onChange={onChange}
                        disabled={disabled}
                        opened={opened}
                        value={selectProjectTypes}
                        onFocus={() => { setOpened(true) }}
                        onBlur={() => { setOpened(false) }}
                        placeholder={placeholder || 'Filter...'}
                        data={projectTypes}
                        textField="Cost_Center"
                    />
                    :
                    <DropDownList valid={isValid} defaultItem={defaultValue} popupSettings={{ className: 'z500' }} onChange={(e) => props.onSelect(e.value)} value={selectProjectType} data={projectTypes} dataItemKey="ID" textField="Cost_Center" loading={projectLoading} required={true} />
                }
            </div>
        </FieldWrapper>
    )
}
